(function(angular){
	'use strict';
	
	angular.module('planModule', [
		'angular.filter',
		'BaseConfig',
		'bigModule',
		'eventsModule',
		'SharedFilters',
		'urlModule'
	]);
})(window.angular);